<template>
    <div>
        <div class="resourceChange-title">
            <div>{{$t( 'resourceLifecycle.resourceChange' )}}</div>
        </div>
        <div class="resourceChange-top">
          <resource-basic-information-search></resource-basic-information-search>
        </div>
    </div>
</template>

<script>
  import ResourceBasicInformationSearch from '../resource_change/ResourceBasicInformationSearch'

    export default {
        name: 'ResourceChange',
        components: {
          ResourceBasicInformationSearch
        },
        data () {
            return {

            }
        },
        methods: {
        }
    }
</script>

<style scoped>
    .resourceChange-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 15px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .resourceChange-title>div:nth-child(1)
    {
        float:left;
    }
    .resourceChange-top
    {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_change/ResourceChange.vue